export class StateOfChargeMeasurementPoint {
    public sensorValue: number;
    public measuredAt: Date;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export class VehicleStateOfChargeData {
    public vehicleInventoryNumber: string;
    public history: StateOfChargeMeasurementPoint[];
    public prognosis: StateOfChargeMeasurementPoint[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
